import React from "react";
import { IconButton, Box } from "@mui/material";
import { MailOutline } from "@mui/icons-material";

const NotificationBadgeIcon = ({ totalUnread, onClick, sx = {} }) => {
  return (
    <IconButton onClick={onClick} sx={{ mx: 0.5, position: "relative", ...sx }}>
      <MailOutline
        sx={{
          color: sx.color || process.env.REACT_APP_COLOR_ICON || "white",
          fontSize: sx.fontSize || 24,
        }}
      />
      {totalUnread > 0 && (
        <Box
          component="span"
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
            backgroundColor: "#d32f2f",
            color: "white",
            fontSize: "10px",
            fontWeight: 600,
            lineHeight: 1,
            height: 18,
            minWidth: 18,
            borderRadius: "9px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 4px",
            boxSizing: "border-box",
          }}
        >
          {totalUnread > 99 ? "99+" : totalUnread}
        </Box>
      )}
    </IconButton>
  );
};

export default NotificationBadgeIcon;
